import React from 'react';
import styled from 'styled-components/macro';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';
import { translations } from '../../../../../locales/translations';

export function TermTable(props) {
  const { t } = useTranslation();
  const rows = props.contractLineData;

  return (
    <Wrapper>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size='small'>
          <TableHead>
            <TableRow>
              <TableCell align='center' className='table-header'>
                {t(translations.contractDetail.amendment.contractLineID)}
              </TableCell>
              <TableCell align='center' className='table-header'>
                {t(
                  translations.contractDetail.amendment.termination
                    .contractEndDate,
                )}
              </TableCell>
              <TableCell align='center' className='table-header'>
                {t(
                  translations.contractDetail.amendment.termination.oldTermDate,
                )}
              </TableCell>
              <TableCell align='center' className='table-header'>
                {t(
                  translations.contractDetail.amendment.termination.newTermDate,
                )}
              </TableCell>
            </TableRow>
          </TableHead>
          {rows.length > 0 ? (
            <TableBody>
              {rows.map(row => (
                <TableRow
                  key={row.contractLineId}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell align='center'>{row.contractLineId}</TableCell>
                  <TableCell align='center'>{row.contractLineEndDate}</TableCell>
                  <TableCell align='center'>{row.oldTerminationDate}</TableCell>
                  <TableCell align='center'>{row.newterminationDate}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          ) : null}
        </Table>
      </TableContainer>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  margin-top: 5px;

  .table-header {
    background: ${p => p.theme.primary};
    color: ${p => p.theme.background};
  }

  .MuiTableCell-root {
    font-size: 12px;
    padding: 2px;
    line-height: 15px;
    border-right: 1px solid rgba(224, 224, 224, 1) !important;
    width: 100px;
  }
`;
